"use client";
import { Dispatch, useCallback, useEffect, useMemo, useState } from "react";
import { TextInput, TextInputProps } from "../components/core/Input/TextInput";

export type Input<T> = {
  jsx: JSX.Element;
  value: T;
  isError: boolean;
  setInputStateManually: Dispatch<React.SetStateAction<T>>;
  clearInput: () => void;
  setErrorStateManually: Dispatch<React.SetStateAction<boolean>>;
};
type UseInputProps<T> = Omit<
  TextInputProps<T>,
  "onChange" | "value" | "setIsError" | "isError"
> & { initalValue: T; isError?: boolean };

function useInput<T>(props: UseInputProps<T>): Input<T> {
  const { initalValue } = props;
  const [state, setState] = useState(initalValue);

  const [isError, setIsError] = useState(false);
  useEffect(() => {
    setIsError(!!props.isError);
  }, [props.isError]);

  const jsx = useMemo(
    () => (
      <>
        <TextInput
          onChange={setState}
          value={props.type === "file" ? undefined : state}
          isError={isError}
          setIsError={setIsError}
          {...props}
        />
      </>
    ),
    [isError, props, state]
  );
  const clearInput = useCallback(() => {
    setState(initalValue);
    setIsError(false);
  }, [initalValue]);

  return {
    jsx,
    value: state,
    isError,
    clearInput,
    setInputStateManually: setState,
    setErrorStateManually: setIsError
  };
}

export default useInput;
